import { IDrop } from "src/core/drops/api/drops.api";
import { IRole } from "src/core/shared/api/roles.api";

export const orderPlacedRedirectPath = (orderId: number, drop: IDrop, role: IRole, preauth: boolean): string => {
  // if payment required, redirect to checkout page
  if (drop.groupedSettings?.require_payment_method?.value?.required) {
    // but not if the platform is set to preauth payments then dont go to the checkout page
    if (!preauth) {
      return `/orders/${orderId}/checkout`;
    }
  }

  if (role?.code === "van-sales-admin") {
    return `/van-sales/orders/${orderId}/order-placed`;
  } else {
    return `/orders/${orderId}/order-placed`;
  }
};
